import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Home, Activity, ClipboardList, Siren, Menu } from "lucide-react";
import MoreDrawer from "@/components/MoreDrawer";

/**
 * v1.2 — Mobile bottom-tab nav.
 * 5 fixed items: Home · Live · Pre-regs · Evacuation · More
 * "More" opens a drawer with operational rest + Settings + Sign out.
 */
const ITEMS = [
  { to: "/dashboard",         label: "Home",     icon: Home,         end: true,  testid: "bnav-home" },
  { to: "/dashboard/live",    label: "Live",     icon: Activity,     end: false, testid: "bnav-live" },
  { to: "/pre-registrations", label: "Pre-regs", icon: ClipboardList, end: true,  testid: "bnav-pre-regs" },
  { to: "/evacuation",        label: "Evac",     icon: Siren,        end: true,  testid: "bnav-evacuation" },
];

export default function BottomNav() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <nav
        className="md:hidden fixed bottom-0 left-0 right-0 z-30 bg-white dark:bg-navy-800 border-t border-navy-100 dark:border-navy-700 flex items-stretch h-16 pb-safe"
        data-testid="bottom-nav"
      >
        {ITEMS.map((it) => {
          const Icon = it.icon;
          return (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={it.testid}
              className={({ isActive }) =>
                `flex-1 flex flex-col items-center justify-center gap-0.5 text-[10px] font-medium ${
                  isActive ? "text-orange-600" : "text-navy-500 dark:text-navy-300"
                }`
              }
            >
              <Icon className="w-5 h-5" />
              {it.label}
            </NavLink>
          );
        })}
        <button
          onClick={() => setOpen(true)}
          data-testid="bnav-more"
          className="flex-1 flex flex-col items-center justify-center gap-0.5 text-[10px] font-medium text-navy-500 dark:text-navy-300"
        >
          <Menu className="w-5 h-5" />
          More
        </button>
      </nav>
      <MoreDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
}
